import { useEffect, useState } from 'react';
import { indonesianDateFormat } from './helpers';
import { useLocation, useSearchParams } from 'react-router-dom';
import { getDetailDriver } from 'features/drivers/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';

const useCreateTableData = (data = []) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const user = useSelector((state) => state.user.profile);

  const isCarCharterEnabled = useFliptBoolean('FLAG_CHARTER', false, user?.id || 'anonymous');

  const [searchParams] = useSearchParams();

  const [driver, setDriver] = useState([]);

  const getDriverCar = (car, driverId, serviceId, vehicle) => {
    if (location.pathname !== '/driver' || searchParams.get('tab-active') !== 'Driver Task') {
      return;
    }

    const getDriverVehicleName = () => {
      if (!driverId || !driver) return '-';

      if (car !== 'driver_car') {
        return car;
      }

      const selectedDriver = driver.find((item) => item.id === driverId);
      return selectedDriver?.vehicle?.name ?? '-';
    };

    if (isCarCharterEnabled) {
      if (!serviceId) return car;

      if (serviceId === 7) {
        return getDriverVehicleName();
      }

      if (serviceId === 8 || serviceId === 9) {
        return vehicle?.name ?? '-';
      }
    }

    return getDriverVehicleName();
  };

  const getServiceType = (serviceId) => {
    switch (serviceId) {
      case 8:
      case 9:
        return 'Car Charter';
      case 7:
        return 'Airport Transfer';
      default:
        return '-';
    }
  };

  useEffect(() => {
    if (location.pathname !== '/driver' && searchParams.get('tab-active') !== 'Driver Task') return;
    const getDriverData = async () => {
      if (data?.length > 0) {
        const driverIdToFetch = data
          .map((item) => item.driver_id)
          .filter((item) => item !== '')
          .filter((item, index, self) => self.indexOf(item) === index);

        if (driverIdToFetch.length === 0) return;

        const promises = driverIdToFetch.map((item) => dispatch(getDetailDriver(item)).unwrap());
        const results = await Promise.allSettled(promises);
        const fulfilledResults = results.filter((result) => result.status === 'fulfilled').map((item) => item.value);
        setDriver(fulfilledResults);
      }
    };

    getDriverData();
  }, [data]);

  const tableData = data.map((item) => ({
    id: item.id,
    name: item.user_name,
    car_type: item?.order_detail?.vehicle?.name || '-',
    package_type:
      (item.order_type_id === 7 ? item.order_detail.vehicle?.category?.name : item.order_airport_package?.title) || '-',
    start_date: indonesianDateFormat(item.order_detail.start_booking_date),
    end_date: indonesianDateFormat(item.order_detail.end_booking_date),
    start_time: item.order_detail.start_booking_time?.slice(0, 5),
    total_payment: item.total_payment,
    status: item?.order_approval_status ? 'waiting_approval' : item?.order_status?.toLowerCase(),
    status_cancelation: item?.order_cancelation?.Status?.toLowerCase(),
    rent_status: 'Perpanjang Sewa',
    deposit_status: item?.is_deposit_exists,
    deposit: item?.deposit || item?.total_payment / 2,
    type: item?.type === 'FULL' ? 'FULL' : item?.payment_time !== null ? 'FULL' : 'HALF',
    order_approval_status: item?.order_approval_status || '',
    order_type_id: item.order_type_id,
    rent_time: item?.rent_time,
    fee: item?.fee,
    driver_id: item?.driver_id || '-',
    task_id: item?.task_id,
    is_driver_task: item?.is_driver_task,
    task_type: item?.task_type,
    car: getDriverCar(item?.car, item?.driver_id, item?.service_id, item?.vehicle) || '-',
    is_task_active: item?.is_running_driver_task,
    platform: item?.platform || '-',
    rating: item?.reviews?.[0].rating || 0,
    ...(isCarCharterEnabled && {
      service: getServiceType(item.service_id),
    }),
  }));

  return { data: tableData };
};

export default useCreateTableData;
